import React, { Component } from "react";
import { Button, Accordion } from "react-bootstrap";
import moment from "moment";

class HomeworkCard extends Component {
  render() {
    let { data, handleDelete } = this.props;
    return (
      <div className="border shadow-sm rounded mb-3 p-3">
        <Accordion defaultActiveKey={null}>
          <Accordion.Toggle
            as={Button}
            variant="link"
            eventKey="1"
            style={{
              padding: 0,
              textDecoration: "none",
              boxShadow: "none",
              width: "100%",
            }}
          >
            <div className="th-14 th-medium th-cap th-black text-left">
              {data?.homework_title}
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <div className="th-12 th-grey text-left">
                {data?.subject?.subject} - {data?.for_class?.class_name}{" "}
                {data?.for_section?.map((each) => {
                  return <span>{each?.section_name}, </span>;
                })}
              </div>

              <i className="fa fa-angle-down th-primary" aria-hidden="true"></i>
            </div>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="1">
            <div className="mt-2">
              <div className="d-flex justify-content-between align-items-center">
                <div className="th-12 th-black text-left th-grey">
                  <div>Homework: {data.homework_date}</div>
                </div>
                <div className="th-12 th-black text-left th-grey">
                  <div>Submission: {data.submission_date}</div>
                </div>
              </div>

              <div className="th-12 d-flex th-grey text-left pt-2">
                {data?.file ? (
                  <div className="col-6 px-1">
                    <a href={data?.file}>
                      {" "}
                      <div
                        type="button"
                        className="btn mt-2 th-att-btn btn-block"
                      >
                        Download
                      </div>
                    </a>
                  </div>
                ) : null}

                {moment().format("YYYY-MM-DD") === data?.homework_date ? (
                  <div className="col-6 px-1">
                    <div
                      onClick={() => handleDelete(data.id)}
                      type="button"
                      className="btn mt-2 th-att-btn btn-block"
                    >
                      Delete
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </Accordion.Collapse>
        </Accordion>
      </div>
    );
  }
}
export default HomeworkCard;
